import React, { useState, useEffect, useRef } from "react";
import {
  CloseOutlined,
  ErrorOutlineOutlined,
  MicExternalOnOutlined,
  NightlifeOutlined,
  VolunteerActivismOutlined,
  SportsBasketballOutlined,
  FastfoodOutlined,
  BusinessCenterOutlined,
  Check,
  TheaterComedy,
} from "@mui/icons-material";
import {
  Alert,
  FormControl,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@mui/material";
import { api } from "../../../services/api";

const categoriaIcons = {
  1: <NightlifeOutlined sx={{ marginRight: "10px" }} />,
  2: <VolunteerActivismOutlined sx={{ marginRight: "10px" }} />,
  3: <SportsBasketballOutlined sx={{ marginRight: "10px" }} />,
  4: <FastfoodOutlined sx={{ marginRight: "10px" }} />,
  5: <BusinessCenterOutlined sx={{ marginRight: "10px" }} />,
  6: <MicExternalOnOutlined sx={{ marginRight: "10px" }} />,
  7: <TheaterComedy sx={{ marginRight: "10px" }} />,
};

const DetailsSection = ({ error, onDetailsChange }) => {
  const refSeccion = useRef({});
  const [expandedSection, setExpandedSection] = useState(false);
  const [tipos, setTipos] = useState("");
  const [eventos_tipos_id, setEventotipo] = useState("");
  const [publicoprivado, setPublicoPrivado] = useState("");
  const [conSalida, setConSalida] = useState(false);

  useEffect(() => {
    if (onDetailsChange) {
      onDetailsChange({
        eventos_tipos_id,
        publicoprivado,
        conSalida,
      });
    }
  }, [eventos_tipos_id, publicoprivado, conSalida, onDetailsChange]);

  const handleSectionClick = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const getEventosTipos = async () => {
      try {
        const response = await api.eventos.getAllEventosTipos();
        if (response.status === "success") {
          setTipos(response.data.eventoTipos);
        }
      } catch (error) {
        console.error("Error: " + error);
      }
    };
    getEventosTipos();
  }, []);

  const handleChangeConSalida = (event) => {
    setConSalida(event.target.checked);
  };
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
  };

  const [tipoSelected, setTipoSelected] = useState(eventos_tipos_id);
  const handleTipoSelect = (id) => {
    setTipoSelected(id);
    setEventotipo(id);
  };

  return (
    <>
      <div
        ref={(el) => (refSeccion.current["detail"] = el)}
        className={`seccion-evento ${
          expandedSection === "detail" ? "expanded" : ""
        }`}
        onClick={() => handleSectionClick("detail")}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex justify-content-between align-items-center gap-3">
            <p
              className={`titulo-seccion-evento ${
                expandedSection === "detail" ? "hidden" : ""
              }`}
            >
              Detalles adicionales
            </p>
            <Chip
              className={`${expandedSection === "detail" ? "hidden" : ""}`}
              icon={<Check sx={{ color: "#5656FF !important" }} />}
              size="small"
              label="Requerido"
              sx={{ backgroundColor: "#E6E6FF", color: "#5656FF" }}
            />
          </div>
          {(error.eventos_tipos_id || error.publicoprivado) && (
            <ErrorOutlineOutlined
              sx={{
                color: "red",
                display: expandedSection === "detail" ? "none" : "block",
              }}
            />
          )}
        </div>
        <p
          className={`descrip-seccion-evento ${
            expandedSection === "detail" ? "hidden" : ""
          }`}
        >
          Proporciona información clave sobre tu evento.
        </p>

        {expandedSection === "detail" && (
          <div className="contenido-evento">
            <FormControl onClick={handleInputClick}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="titulo-seccion-evento-expanded">
                  Detalles adicionales
                </p>
                <button
                  type="button"
                  onClick={() => handleSectionClick("detail")}
                  className="d-flex justify-content-end"
                >
                  <CloseOutlined sx={{ color: "#3659E3" }} />
                </button>
              </div>

              <p className="subtitulo-seccion-evento-expanded">
                Tipo de evento <span className="text-danger">*</span>
              </p>
              <p className="descrip-seccion-evento-expanded">
                Define la naturaleza del evento. Selecciona entre estas opciones
                la que mejor se asemeje a tu evento.
              </p>

              {tipos?.length > 0 ? (
                <div className="row">
                  {tipos.map((tipo) => (
                    <div key={tipo.id} className="col-12 col-md-6 mb-3">
                      <button
                        id="eventos_tipos_id"
                        name="eventos_tipos_id"
                        type="button"
                        onClick={() => handleTipoSelect(tipo.id)}
                        onChange={(e) =>
                          setEventotipo(parseInt(e.target.value))
                        }
                        className={`w-100 boton-tipo ${
                          tipoSelected === tipo.id ? "boton-tipo-active" : ""
                        }`}
                      >
                        <span className="d-flex align-items-center">
                          {categoriaIcons[tipo.id]}
                          {tipo.evento_tipo}
                        </span>
                        <span className="indicator-wrapper">
                          <span className="indicator-fuera"></span>
                          <span className="indicator-dentro"></span>
                        </span>
                      </button>
                    </div>
                  ))}
                  {error.eventos_tipos_id && (
                    <div className="col-12">
                      <Alert severity="error" className="mb-4">
                        {error.eventos_tipos_id}
                      </Alert>
                    </div>
                  )}
                </div>
              ) : (
                <span color="error">Error..</span>
              )}
            </FormControl>

            <FormControl onClick={handleInputClick}>
              <p className="subtitulo-seccion-evento-expanded">
                Visibilidad del Evento <span className="text-danger">*</span>
              </p>
              <p className="descrip-seccion-evento-expanded">
                Establece la accesibilidad de tu evento. Ten cuidado, esta
                opción no podrá modificarse después.
              </p>
              <div className="d-flex flex-wrap flex-row gap-3">
                <button
                  type="button"
                  onClick={() => setPublicoPrivado("false")}
                  className={`mr-2 mb-2 ${
                    publicoprivado === "false"
                      ? "boton-tipo-active"
                      : "boton-tipo"
                  }`}
                >
                  <div className="d-flex flex-column">
                    <span className="text-left">Evento público</span>
                    <span className="descripcion-boton">
                      Todos podrán verlo.
                    </span>
                  </div>
                  <span className="indicator-wrapper">
                    <span className="indicator-fuera"></span>
                    <span className="indicator-dentro"></span>
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => setPublicoPrivado("true")}
                  className={`mr-2 mb-2 ${
                    publicoprivado === "true"
                      ? "boton-tipo-active"
                      : "boton-tipo"
                  }`}
                >
                  <div className="d-flex flex-column">
                    <span className="text-left">Evento privado</span>
                    <span className="descripcion-boton text-left">
                      Restringido a miembros de la organización.
                    </span>
                  </div>
                  <span className="indicator-wrapper">
                    <span className="indicator-fuera"></span>
                    <span className="indicator-dentro"></span>
                  </span>
                </button>
              </div>
              <>
                {error.publicoprivado && (
                  <Alert severity="error" className="my-2">
                    {error.publicoprivado}
                  </Alert>
                )}
              </>
            </FormControl>
            <FormControl>
              <p className="subtitulo-seccion-evento-expanded">
                Ingreso y Reingreso de Invitados
              </p>
              <p className="descrip-seccion-evento-expanded">
                Selecciona si los invitados podrán ingresar y reingresar al
                evento en cualquier momento.
              </p>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={conSalida}
                    onChange={handleChangeConSalida}
                    onClick={handleCheckboxClick}
                  />
                }
                label="Habilitar reingreso para invitados"
              />
            </FormControl>
          </div>
        )}
      </div>
    </>
  );
};

export default DetailsSection;
